import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { Stack, Typography } from '@monorepo/nova-ui';

export const MidnightEmptyState: FC = () => {
  const { t } = useTranslation(['common']);

  return (
    <Stack alignItems="center" justifyContent="center" minHeight={200} gap={2}>
      <SystemIcon iconName="ICalendarBlank" size={48} color="action" />
      <Typography variant="h6" align="center">
        {t('common:no_data')}
      </Typography>
    </Stack>
  );
};
